function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useState, useEffect, useRef } from 'react';
import { toast } from 'react-hot-toast';
import { useAuth } from '@edusense/shared-auth-core';
import { validateId } from '../utils';
export var useSocialActions = function(param) {
    var id = param.id, isLiked = param.isLiked, isRetweetedByMe = param.isRetweetedByMe, isBookmarked = param.isBookmarked, onLike = param.onLike, onRetweet = param.onRetweet, onQuote = param.onQuote, onComment = param.onComment, onBookmark = param.onBookmark;
    // 상태 관리
    var _useState = _sliced_to_array(useState(isLiked), 2), liked = _useState[0], setLiked = _useState[1];
    var _useState1 = _sliced_to_array(useState(isRetweetedByMe), 2), retweeted = _useState1[0], setRetweeted = _useState1[1];
    var _useState2 = _sliced_to_array(useState(isBookmarked), 2), bookmarked = _useState2[0], setBookmarked = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), showRetweetOptions = _useState3[0], setShowRetweetOptions = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), isReplyModalOpen = _useState4[0], setIsReplyModalOpen = _useState4[1];
    var retweetOptionsRef = useRef(null);
    var isAuthenticated = useAuth().isAuthenticated;
    // 리트윗 옵션 외부 클릭 감지
    useEffect(function() {
        var handleClickOutside = function(event) {
            if (retweetOptionsRef.current && !retweetOptionsRef.current.contains(event.target)) {
                setShowRetweetOptions(false);
            }
        };
        if (showRetweetOptions) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return function() {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        showRetweetOptions
    ]);
    // props가 변경되면 내부 상태도 업데이트
    useEffect(function() {
        setLiked(isLiked);
        setRetweeted(isRetweetedByMe);
        setBookmarked(isBookmarked);
    }, [
        isLiked,
        isRetweetedByMe,
        isBookmarked
    ]);
    // 좋아요 클릭 핸들러
    var handleLike = function(e) {
        e.stopPropagation();
        if (!isAuthenticated) {
            toast.error('로그인이 필요합니다.');
            return;
        }
        if (!validateId(id)) return;
        var newLiked = !liked;
        setLiked(newLiked);
        if (onLike) {
            onLike(id, newLiked);
        }
    };
    // 리트윗 옵션 버튼 클릭 처리
    var handleRetweetClick = function(e) {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        if (!isAuthenticated) {
            toast.error('로그인이 필요합니다.');
            return;
        }
        setShowRetweetOptions(!showRetweetOptions);
    };
    // 리트윗 처리
    var handleRetweet = function(e) {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        if (!validateId(id)) return;
        var newRetweeted = !retweeted;
        setRetweeted(newRetweeted);
        if (onRetweet) {
            onRetweet(id);
        }
        setShowRetweetOptions(false);
    };
    // 인용 트윗 기능
    var handleQuoteTweet = function(e) {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        setShowRetweetOptions(false);
        if (!validateId(id)) return;
        console.log('[SocialActions] Quote tweet requested for tweet:', id);
        if (onQuote) {
            onQuote(id, '');
        }
    };
    // 답글/댓글 작성 핸들러
    var handleComment = function(e) {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        if (!isAuthenticated) {
            toast.error('로그인이 필요합니다.');
            return;
        }
        if (!validateId(id)) {
            toast.error('트윗 ID가 유효하지 않습니다.');
            return;
        }
        if (onComment) {
            onComment(id);
            return;
        }
        setIsReplyModalOpen(true);
    };
    // 북마크 클릭 핸들러
    var handleBookmark = function(e) {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        if (!isAuthenticated) {
            toast.error('로그인이 필요합니다.');
            return;
        }
        if (!validateId(id)) return;
        var newBookmarked = !bookmarked;
        setBookmarked(newBookmarked);
        if (onBookmark) {
            onBookmark(id, newBookmarked);
        }
    };
    return {
        // 상태
        liked: liked,
        retweeted: retweeted,
        bookmarked: bookmarked,
        showRetweetOptions: showRetweetOptions,
        isReplyModalOpen: isReplyModalOpen,
        setIsReplyModalOpen: setIsReplyModalOpen,
        retweetOptionsRef: retweetOptionsRef,
        // 핸들러
        handleLike: handleLike,
        handleRetweetClick: handleRetweetClick,
        handleRetweet: handleRetweet,
        handleQuoteTweet: handleQuoteTweet,
        handleComment: handleComment,
        handleBookmark: handleBookmark
    };
};
